import { useContent } from '../hooks/useContent';
import './About.css';

const About = () => {
  const { ui } = useContent();
  const a = ui.about;

  return (
    <section>
      <div className="section">
        <div className="about-grid">
          <div className="about-visual">
            <div className="about-card-main">
              <h3>{a.missionTitle}</h3>
              <p>{a.missionText}</p>
            </div>
            <div className="about-cards-secondary">
              {a.cards.map((card) => (
                <div key={card.title} className="about-mini-card">
                  <h4>{card.title}</h4>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="about-text">
            <div className="section-label">{a.label}</div>
            <h2 className="section-title">
              {a.title}
              <br />
              <em>{a.titleEm}</em>
              <br />
              {a.titleEnd}
            </h2>
            <p className="section-subtitle">{a.subtitle}</p>

            <div className="values-list">
              {a.values.map((v, i) => (
                <div key={v.title} className="value-item">
                  <div className="value-num">{String(i + 1).padStart(2, '0')}</div>
                  <div className="value-content">
                    <h4>{v.title}</h4>
                    <p>{v.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
